import { render, staticRenderFns } from "./SlugRedirectorView.vue?vue&type=template&id=3be6c1f9"
import script from "./SlugRedirectorView.vue?vue&type=script&lang=js"
export * from "./SlugRedirectorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports